import Rooms from './rooms';
import Transfer from './transfer';

export default function(){
  if (document.querySelector('.js-room-list-item')) new Rooms();
  if (document.querySelector('.js-transfer-list')) new Transfer();
}


/** WEBPACK FOOTER **
 ** ./assets/js/pages/index.js
 **/